var module = angular.module('octopusApp.shared');

module.directive('variableSetSnapshot', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      snapshotId: '=id',
      limitWidth: '='
    },
    templateUrl: 'areas/shared/views/variable-set-snapshot.html',
    controller: function($scope, octopusRepository, busy) {
      var isLoading = $scope.isLoading = busy.create();

      var formatted = {};

      $scope.$watch('snapshotId', function(){
        if (!$scope.snapshotId) {
          return;
        }
        isLoading.promise(octopusRepository.Variables.get($scope.snapshotId).then(function(variables) {
          $scope.snapshot = variables;
          $scope.scopeValues = variables.ScopeValues;
        }));
      });
      $scope.formatScope = function(variableId, varscope, scopeValues) {
        if (!varscope || !scopeValues) {
          return '';
        }
        if (formatted[variableId]) {
          return formatted[variableId];
        }

        var values = [];
        _.each(_.sortBy(_.pairs(varscope), function(pr) { return pr[0]; }), function(pr){
          var refs = scopeValues[pr[0] + 's'];
          _.each(pr[1], function(id) {
            var item = _.find(refs, function(ref) { return ref.Id === id; });
            if (item) {
              values.push(item.Name);
            }
          });
        });
        var result = values.join('; ');
        formatted[variableId] = result;
        return result;
      };
    }
  };
});






//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/variable_set_snapshot.js
// module id = 604
// module chunks = 1